import React from 'react'

type Props = {}

const PrivacyPolicy = (props: Props) => {
    return (
        <div>PrivacyPolicy</div>
    )
}

export default PrivacyPolicy
